// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — zone.classic.js, новая — zone.cp.js
import { isCp } from 'libs/design';
import * as classic from './zone.classic';
import * as cp from './zone.cp';

export const Zone = isCp ? cp.Zone : classic.Zone;
